angular.module("cruscottoRichiestaClienti.components", []).component("cruscottoRichiestaClienti", {
  templateUrl: "ng/components/cruscottoRichiestaClienti/cruscottoRichiestaClienti.view.html",
  controllerAs: "cruscottoRichiestaClientiCtrl",
  controller: function CruscottoRichiestaClienti(
    $financialApiService,
    $location,
    $transactionFactory
  ) {
    var self = this;

    self.$onInit = function () {
      self.supportModel = {
        filter: undefined,
        listPractice: undefined,
        isPending: true,
        appRichiestePostVenditaCount: undefined
      }
    };

    self.onPressSearch = function (filter) {
      self.supportModel.filter = filter;
      self.getPracticeList();
    }

    self.$onDestroy = function() {
      if ($location.path() !== "/dettaglioCruscottoRichiestaClienti") {
        sessionStorage.removeItem('cruscotto');
      } 
    }

    self.getPracticeList = function () {
      self.supportModel.isPending = true;
      var filter= $transactionFactory.getFilters();
      var isReturn = localStorage.getItem('isReturnDettaglioCruscotto')
      if(filter && isReturn ){
        localStorage.removeItem('isReturnDettaglioCruscotto');
        self.supportModel.filter= filter;
      }

      $financialApiService.richiestePostVendita(self.supportModel.filter)
        .then(function (response) {
          self.supportModel.listPractice = response.appRichiestePostVendita
          self.supportModel.appRichiestePostVenditaCount = response.appRichiestePostVenditaCount
          self.supportModel.filter.totalPages = Math.ceil(
            response.appRichiestePostVenditaCount / 10 
          );
          self.supportModel.isPending = false;
          $transactionFactory.setFilters(self.supportModel.filter);
        })
        .catch(function () {
          self.supportModel.isPending = false;
        })
    }
  }
})